// UserTermsTemplateコンポーネントをインポート
// ユーザー向けの「利用規約」ページ用テンプレートとして使用
import UserTermsTemplate from "../templates/UserTermsTemplate";

/**
 * UserTermsPageコンポーネント
 * ユーザー向けの「利用規約」ページを表示するためのコンポーネント
 * UserTermsTemplateを利用して利用規約画面を構築
 */
const UserTermsPage = () => {

    // 利用規約ページテンプレートをレンダリング
    // 特別なプロパティを渡さず、UserTermsTemplateをそのまま利用
    return (
        <UserTermsTemplate />
    );
}

// UserTermsPageコンポーネントをデフォルトエクスポート
// 他のファイルからこのコンポーネントをインポートして利用可能にする
export default UserTermsPage;
